import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _findLast from 'lodash/findLast';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Custom
import { asyncOperationDataShape } from 'constants/PropTypesShapes';
import { ASYNC_OP_STATUS_PENDING } from 'constants/App';
import { TriggerContainedButton } from 'components/buttons/ContainedButtons';
import { TriggerIconButton } from 'components/buttons/IconButtons';

const ScenarioTriggerButtonContent = React.memo(({ type, loading, onClick }) => {
  // Button props
  const buttonProps = {
    context: 'warning',
    loading,
    onClick,
  };

  if (type === 'contained') {
    return (
      <TriggerContainedButton {...buttonProps} />
    );
  }
  if (type === 'icon') {
    return (
      <TriggerIconButton primary {...buttonProps} />
    );
  }
  return null;
});

ScenarioTriggerButtonContent.displayName = 'ScenarioTriggerButtonContent';

ScenarioTriggerButtonContent.propTypes = {
  type: PropTypes.oneOf(['contained', 'icon']).isRequired,
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const ScenarioTriggerButton = ({
  type, installationTrigger, asyncOperations, onTrigger,
}) => {
  // Try to find async operation associated (installationTrigger may be null)
  const asyncOperation = _find(asyncOperations, ['id', _get(installationTrigger, 'asyncOperationId')]);

  // Component props
  const compProps = {
    type,
    loading: _get(asyncOperation, 'status') === ASYNC_OP_STATUS_PENDING,
    onClick: onTrigger,
  };

  return (
    <ScenarioTriggerButtonContent {...compProps} />
  );
};

ScenarioTriggerButton.propTypes = {
  id: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  type: PropTypes.oneOf(['contained', 'icon']),
  installationTrigger: PropTypes.shape({
    resource: PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
    asyncOperationId: PropTypes.number.isRequired,
  }),
  asyncOperations: PropTypes.arrayOf(asyncOperationDataShape).isRequired,
  onTrigger: PropTypes.func.isRequired,
};

ScenarioTriggerButton.defaultProps = {
  type: 'contained',
  installationTrigger: null,
};

const mapStateToProps = (state, ownProps) => ({
  installationTrigger: _findLast(state.installationTrigger.list, (installationTrigger) => (
    _get(installationTrigger, 'resource.type') === 'scenario' && _get(installationTrigger, 'resource.id') === ownProps.id)),
  asyncOperations: state.asyncOperation.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ScenarioTriggerButton);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ScenarioTriggerButton.js